angular.module('tf.controllers')

    .controller('ProjectController', ['$scope', 'Session', '$state', '$stateParams', 'HttpService', 'Project',
        'UrlEncodingService','RenderService','FarmerService','ConfirmExitService','HeaderService','$rootScope',
        'ProjectService','MixpanelService','$timeout','ThumbnailSequence','NotificationService',
        'ProjectStorageService','TourService', 'ScheduleService', 'FileUploadService', 'FarmService','ShareService',
    function ($scope, Session, $state, $stateParams, HttpService, Project,
              UrlEncodingService, RenderService, FarmerService, ConfirmExitService, HeaderService, $rootScope,
              ProjectService, MixpanelService, $timeout, ThumbnailSequence, NotificationService,
              ProjectStorageService, TourService, ScheduleService, FileUploadService, FarmService, ShareService) {

        $scope.showTiles = false;
        $scope.items = [];
        $scope.path = $stateParams.path;
        $scope.displayMode = 0;
        $scope.progress = {};
        $scope.selectedTemplate = {};
        $scope.isSingleTemplate = true;
        $scope.canProduce = false;
        $scope.safeNameRegex = ProjectService.safeNameRegex;

        $scope.session = Session;
        var isFarmProduceAvailable = false;
        var safeApplyInterval;
        var isFarmProduceAvailable = false;

        var isDemo = $scope.isDemo = function () {
            return !!$stateParams.demo;
        };

        function checkCanProduce(){
            $scope.loadingCanProduce = true;
            FarmService.checkCanProduce().then(function (res) {
                $('.project-menu .project-menu-right .project-produce-button i.fa-spin').removeClass('fa-spin');
                isFarmProduceAvailable = res.data;
                $scope.loadingCanProduce = false;
            });
        }

        $scope.goToUpgrade = function () {
            FarmService.goToUpgrade('To produce more videos contact', {initiator:'upgrade to add more videos - project'});
        };

        $scope.isProduceAvailable = function () {
            return isFarmProduceAvailable;
        };

        $scope.isButtonDisabled = false;

        $scope.handleClick = function() {
            if ($scope.isProduceAvailable()) {
                $scope.render();
            } else {
                $scope.goToUpgrade();
            }
    
            $scope.isButtonDisabled = true;
    
            $timeout(function() {
                $scope.isButtonDisabled = false;
            }, 1000);
        };

        

       /* if ($scope.path) {
            //var dec = UrlEncodingService.decode($scope.path);
            $scope.fid = FarmerService.fid();
            $scope.path = FarmerService.path();
            $scope.type = FarmerService.type();

            RenderService.fid = $scope.fid;
            RenderService.path = $scope.path;
        }
        if ($scope.fid && $scope.path) {
            getProject($scope.fid, $scope.path)
        }*/

        $scope.selectTemplate = function(template){
            $scope.selectedTemplate = template;
            for(var i = 0 ; i < $scope.project.templates.length ; i++){
                $scope.project.templates[i].isSelected = false;
            }
            template.isSelected = true;

            $scope.selectedTemplate.thumbnail = template.thumbnail;
            if(!$scope.selectedTemplate.thumbnailSequence){
                $scope.selectedTemplate.thumbnailSequence = new ThumbnailSequence();
            }
        };

        function initProject(selectedTemplateIndex, isReloadPage){
            isReloadPage = isReloadPage || false;
            checkCanProduce();
            $scope.project = ProjectService.project;
            RenderService.project = $scope.project;
            HeaderService.setName($scope.project.name);
            HeaderService.setLogo($scope.project.logo);
            $scope.canProduce = false;


            for(var i = 0 ; i < $scope.project.templates.length ; i++) {
                getThumbnail($scope.project.templates[i]);
            }

            if($scope.project.templates.length === 1){
                $scope.project.templates[0].use = true;
                $scope.canProduce = true;
                $scope.selectTemplate($scope.project.templates[0]);
                $scope.displayMode = 1;

                for(var j = 0 ; j < $scope.project.templates.length ; j++){
                    if($scope.project.templates[j].settings && $scope.project.templates[j].settings.duplicate){
                        $scope.isSingleTemplate = false;
                        break;
                    }
                }
                //if($scope.project.settings && $scope.project.settings.templatesDuplicate)$scope.isSingleTemplate=false;
            }else{
                var visibleTemplates = 0;
                for(i = 0; i < $scope.project.templates.length ; i++){
                    if(!$scope.project.templates[i].hide) {
                        visibleTemplates++;
                        if($scope.project.templates[i].use)$scope.canProduce = true;
                    }
                }
                if(visibleTemplates === 1){
                    $scope.canProduce = true;
                    for(i = 0;i<$scope.project.templates.length;i++) {
                        if(!$scope.project.templates[i].hide) {
                            $scope.project.templates[i].use = true;
                            $scope.selectTemplate($scope.project.templates[i]);
                            $scope.displayMode = 1;
                        }
                    }
                }else{
                    if(selectedTemplateIndex){
                        $scope.isSingleTemplate = false;
                        $scope.selectTemplate($scope.project.templates[selectedTemplateIndex]);
                    } else if(_.find($scope.project.templates,{isSelected : true})){
                        $scope.isSingleTemplate = false;
                        $scope.selectTemplate(_.find($scope.project.templates,{isSelected : true}));
                    } else {
                        for (i = 0; i < $scope.project.templates.length; i++) {
                            if (!$scope.project.templates[i].hide) {
                                $scope.isSingleTemplate = false;
                                $scope.selectTemplate($scope.project.templates[i]);
                                break;
                            }
                        }
                    }
                }
            }
            if(isReloadPage){
                window.location.reload();
            }
        }

        function validateProject(){
            var valid = true;
            var message = '';
            _.each(ProjectService.project.getTemplates(), function(template){

                var controls = _.pluck(template.controls, 'layer');
                if(controls.length > _.uniq(controls).length){
                    valid = false;

                    message = 'Warning: The composition <b>"' + template.name + '"</b> contains layers with the same name, this may cause unexpected behaviour.<br>' +
                        'To display layers with the same name add <b>"#rename(new-name)"</b> to the layer name';
                }
            });
            if(!valid){
                NotificationService.notify("warn-alert", {content: message}, {x : true, duration: 8});
            }

        }


        initProject();
        // validateProject();
        safeApplyInterval = setInterval(function(){
            $scope.safeApply();
        }, 1000);

        if($scope.project.demo){
            $timeout(function(){TourService.runProjectTour();}, 1000);
        }

        $scope.safeApply = function(fn) {
            var phase = this.$root.$$phase;
            if(phase === '$apply' || phase === '$digest') {
                if(fn && (typeof(fn) === 'function')) {
                    fn();
                }
            } else {
                this.$apply(fn);
            }
        };


        /*function getProject(fid, path) {
            $rootScope.$broadcast('working',true);
            HttpService.get("farmer/" + fid + "/project", { args: path }).then(function (res) {
                $rootScope.$broadcast('working',false);

                ProjectService.project=new Project(res.data);
                $scope.project = ProjectService.project;

                RenderService.project = $scope.project;
                HeaderService.setName($scope.project.name);
                HeaderService.setLogo($scope.project.logo);

                for(var i=0;i<$scope.project.templates.length;i++) {
                    getThumbnail($scope.project.templates[i]);
                }

                if($scope.project.templates.length==1){
                    $scope.project.templates[0].use=true;
                    $scope.canProduce=true;
                    $scope.selectTemplate($scope.project.templates[0]);
                    $scope.displayMode = 1;
                }else{
                    var visibleTemplates=0;
                    for(var i=0;i<$scope.project.templates.length;i++){
                        if(!$scope.project.templates[i].hide) {
                            visibleTemplates++;
                            if($scope.project.templates[i].use)$scope.canProduce=true;
                        }
                    }
                    if(visibleTemplates==1){
                        $scope.canProduce=true;
                        for(var i=0;i<$scope.project.templates.length;i++) {
                            if(!$scope.project.templates[i].hide) {
                                $scope.project.templates[i].use = true;
                                $scope.selectTemplate($scope.project.templates[i]);
                                $scope.displayMode = 1;
                            }
                        }
                    }else{
                        for(var i=0;i<$scope.project.templates.length;i++) {
                            if (!$scope.project.templates[i].hide) {
                                $scope.isSingleTemplate = false;
                                $scope.selectTemplate($scope.project.templates[i]);
                                break;
                            }
                        }
                    }
                }
            }, function(){
                $rootScope.$broadcast('working',false);
                window.location = "/";
            });
        }*/




        $scope.stopPropagation = function (e) {
            // to make sure it is a checkbox
            if (angular.element(e.currentTarget).prop('tagName') === 'INPUT') {
                e.stopPropagation();
            }
        };

        $scope.duplicate = function(template){
            var temp = angular.copy(template);
            temp.canDelete = true;
            $scope.project.templates.splice($scope.project.templates.indexOf(template)+1,0,temp);
        };

        $scope.selectAll=function(){
            for(var i = 0; i < $scope.project.templates.length ; i++){
                $scope.project.templates[i].use = true;
            }
            $scope.canProduce = true;
        };

        $scope.deselectAll=function(){
            for(var i=0;i<$scope.project.templates.length;i++){
                $scope.project.templates[i].use = false;
            }
            $scope.canProduce = false;
        };

        $scope.invertSelection=function(){
            var counter=0;
            for(var i = 0 ; i < $scope.project.templates.length ; i++){
                $scope.project.templates[i].use = !$scope.project.templates[i].use;
                if($scope.project.templates[i].use && !$scope.project.templates[i].hide)counter++;
            }
            $scope.canProduce = counter > 0;
        };

        $scope.delete= function(template){
            $scope.project.templates.splice($scope.project.templates.indexOf( template),1);
        };

        $scope.render = function(watermark){
            RenderService.render(watermark).then(function(){

            }, function(err){
                if(err && err.message === "Missing some required fields"){
                    NotificationService.popup("info-popup", {content : err.message});
                }
            });
        };


        $scope.cancelPreview = {};


        $scope.previewAll = function(){
            $scope.project.templates.forEach(function(template){
                $scope.preview(template);
            });
        };
        $scope.previewSelected = function(){
            $scope.project.templates.forEach(function(template){
                if(template.use) $scope.preview(template);
            });
        };

        $scope.preview = function(template){

            template.previewPending = true;

            RenderService.preview(template).then(
                function(res){
                    //var cid = res.config.headers.cid;
                    var cid = res.data.cid;
                    template.previewCid = cid;
                    var properties = {
                        "cid"           : cid,
                        "template name" : template.originalName,
                        "project id"    : $scope.project.id,
                        "project name"  : $scope.project.name,
                        "fid"           : $scope.project.fid
                    };
                    MixpanelService.sendEvent("preview-started", properties);
                    var stopListener = $scope.$on(cid, function(data, data2){
                        $scope.$apply(function(){

                            if(template.thumbnailSequence) {
                                template.thumbnailSequence.update(data2);
                            } else {
                                template.thumbnailSequence = new ThumbnailSequence(data2);
                            }

                            template.previewPending=false;
                            delete template.previewCid;
                            ProjectService.storeProject();

                            var properties = {
                             "cid"           : cid,
                             "template name" : template.originalName,
                             "project id"    : $scope.project.id,
                             "project name"  : $scope.project.name,
                             "fid"           : $scope.project.fid
                             };
                             MixpanelService.sendEvent("preview-completed", properties);

                        });

                        stopListener();
                    });

                    $scope.cancelPreview[template.id] = function(){
                        stopListener();
                        template.previewPending = false;
                        delete template.previewCid;
                        MixpanelService.sendEvent("preview-canceled", properties);
                        HttpService.post('farmer/' + $scope.project.fid + '/cancel_task', {cid:cid, cancelToken : res.data.cancelToken});
                        $scope.cancelPreview[template.id] = angular.noop;


                    };
                },
                function(err){
                    if(err && err.message === "Missing some required fields"){
                        NotificationService.popup("info-popup", {content : err.message});
                    }
                    template.previewPending=false;
                    delete template.previewCid;
                }
            );
        };

        $scope.clearPreview=function(template) {
            delete template.previewImage;
            template.hasPreview = false;
            template.previewPending = false;
            delete template.previewCid;

        };

        $scope.$on('status', function(e,data){
            if($scope.project.templates.find(function(template){
                return template.previewCid === data.cid && template.isSelected;
            })){
                $scope.progress.status = data;
                $scope.$apply();
            }

        });
        //
        //$scope.$on('progress', function(e,data){
        //    $scope.progress.value=Math.round(data.progress*100);
        //    $scope.$apply();
        //});
        //
        //$scope.$on('start', function(e){
        //    $scope.progress.value = 0;
        //    $scope.progress.isStarted=true;
        //    $scope.$apply();
        //});
        //
        $scope.$on('complete', function(e, data){
            $scope.progress.isStarted = false;
            if(data.taskType === 'preview'){
                $scope.selectedTemplate.previewTime = data.taskTime;
            }
            $scope.$apply();
        });

        $scope.toggleTemplateUse = function(template){
            template.use = !template.use;
            var counter = 0;
            for(var i = 0 ; i < $scope.project.templates.length ; i++){
                if($scope.project.templates[i].use  && !$scope.project.templates[i].hide) counter++;
            }
            $scope.canProduce= counter > 0;
        };

        function getThumbnail(template){
            if(template.thumbnail && (!template.thumbnailSequence || template.thumbnailSequence.isEmpty())){
                template.thumbnailPending = true;
                HttpService.get('farmer/'+ProjectService.project.fid+'/image/', {image: template.thumbnail, size : 1920})
                    .then(function (res) {
                        //template.thumbnailImage=res.data;
                        //template.thumbnailSequence = [res.data];
                        template.thumbnailSequence = new ThumbnailSequence(res.data);
                        template.thumbnailPending = false;

                    });
            }
        }

        $scope.getRowsCount = function(value){
            var result = 1;
            var arr = value.split("\r");
            result=arr.length;
            if(result>1)return result+1;
            else return result;
        };


        $scope.openShareDialog = function(){
            var item = {};
            item.id = $scope.project.id;
            item.name = $scope.project.name;
            item.breadcrumbs = $scope.project.breadcrumbs;
            item.type = 1;
            $scope.shareService.open(item);
        };

        $scope.share = function(){
            if($rootScope.currentLocation) {
                ShareService.open($rootScope.currentLocation);
            }
        };

        $scope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {
            if(_.includes(['app.folder', 'app.farmers'], toState.name) && fromState.name === 'app.project'){
                if(window.onbeforeunload) {
                    event.preventDefault();
                    ConfirmExitService.popup(toState, toParams,
                        'You have made changes to this project', 'If you leave without producing your changes will be lost');
                }
            }else if (FileUploadService.isUploading) {
                    event.preventDefault();
                    ConfirmExitService.popup(toState, {'onLeave':function(){
                                FileUploadService.isUploading = false;
                            }
                        },
                        'File is still uploading', 'Leaving the template will stop the file upload');
                }

            clearInterval(safeApplyInterval);
        });

        var unwatchProject = $scope.$watch(function watchProject(){return $scope.project;}, function(newVal, oldVal){
           if(newVal && oldVal && !projectEq(oldVal,newVal)){
               ProjectStorageService.store($scope.project);
               if(!window.onbeforeunload) {
                   window.onbeforeunload = ConfirmExitService.onBeforeUnload("Are you sure you want to leave this page?");
               }
             //  ConfirmExitService.confirmExit($scope,"Are you sure you want to leave this page?");
             //  unwatchProject();
           }
        },true);


        $scope.reset = function(template){
            var selectedTemplateIndex = $scope.project.getTemplateIndex($scope.selectedTemplate);
            var path = $stateParams.path;
            NotificationService.popup('confirm-reset', {
                'onConfirm': function(){
                    ProjectService.reset(path, template).then(function(){
                        initProject(selectedTemplateIndex);
                    });

                }
            });
        };
        $scope.openProjectSettings = function(path){
            ProjectService.openSettings(path);
        };
        $scope.openScheduler = function(path){
            ScheduleService.openScheduler(path);
        };

        $scope.$on('tf-reset-project', function () {
            var path = $stateParams.path;
            ProjectService.reset(path).then(function(){
                initProject($scope.project.getTemplateIndex($scope.selectedTemplate), true);
            });
        });

        function projectEq(p1, p2){
            var fieldsToCompare = p1.getComparableFields();
            if(p1.name !== p2.name){return false;}
            if(p1.templates.length !== p2.templates.length){return false;}
            for (var i = 0; i < p1.templates.length; i++) {
                var template1 = p1.templates[i];
                var template2 = p2.templates[i];
                if (template1.controls.length !== template2.controls.length) {
                    return false;
                }
                if (template1.use != template2.use){
                    return false;
                }
                if (template1.isSelected != template2.isSelected){
                    return false;
                }
                if (template1.name !== template2.name){
                    return false;
                }
                for (var j = 0; j < template1.controls.length; j++) {
                    var control1 = template1.controls[j];
                    var control2 = template2.controls[j];
                    for(var k = 0 ; k < fieldsToCompare.length ; k++){
                        if(_.isObject(control1[fieldsToCompare[k]]) && _.isObject(control2[fieldsToCompare[k]])){
                            var eq = !_.chain([control1[fieldsToCompare[k]]]).filter(control2[fieldsToCompare[k]]).isEmpty().value();
                            if(!eq) {
                                return false;
                            }
                        } else if (_.isObject(control1[fieldsToCompare[k]]) || _.isObject(control2[fieldsToCompare[k]])) {
                            return false;
                        }else if(control1[fieldsToCompare[k]] !== control2[fieldsToCompare[k]]){
                            return false;
                        }

                    }
                }
            }

            return true;
        }

        $scope.dragOverClass = function($event) {
            var items = $event.dataTransfer.items;
            var hasFile = false;
            if (items !== null) {
                for (var i = 0 ; i < items.length; i++) {
                    if (items[i].kind == 'file' && $scope.project.isAllowedMimeType(items[i].type)) {
                        hasFile = true;
                        break;
                    }
                }
            } else {
                hasFile = true;
            }
            return hasFile ? "dragover" : "dragover-err";
        };

        $scope.populateControls = function(file, template){
            if($scope.project.isAllowedMimeType(file.type)) {
                $scope.project.populateControls(template, file);
            }
        };
        $scope.$on('$destroy', function(){
            clearInterval(safeApplyInterval);
        });

        $scope.splitOptions = {
            selectors:['#template-controls-section', '#render-view-section'],
            initSize:[33, 67],
            minSize:[250,350],
            gutterSize : 5
        };

    }]);
